"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("../../Themes/styled-components"));
var Icon_1 = __importDefault(require("../../Icon"));
var Wrapper = styled_components_1.default('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n  color: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  font-size: ", ";\n  line-height: 1;\n  border: 1px solid ", ";\n  ", "\n  ", "\n"], ["\n  display: inline-block;\n  position: relative;\n  color: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  font-size: ", ";\n  line-height: 1;\n  border: 1px solid ", ";\n  ",
    "\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
}, polished_1.em(5), function (_a) {
    var theme = _a.theme;
    return theme.baseBorderRadius;
}, function (_a) {
    var theme = _a.theme;
    return theme.color.primaryBg;
}, polished_1.em(7), polished_1.em(7), polished_1.em(14), function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
}, function (_a) {
    var onClick = _a.onClick;
    return onClick && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      cursor: pointer;\n    "], ["\n      cursor: pointer;\n    "])));
}, function (_a) {
    var removable = _a.removable;
    return removable && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      padding-right: ", ";\n    "], ["\n      padding-right: ", ";\n    "])), polished_1.em(23));
});
var Title = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 0.65em;\n"], ["\n  font-size: 0.65em;\n"])));
var Subtitle = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject([""], [""])));
var StyledIcon = styled_components_1.default(Icon_1.default)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n  padding: ", ";\n"], ["\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n  padding: ", ";\n"])), polished_1.em(5));
var A = styled_components_1.default.a(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  &:hover {\n    cursor: pointer;\n  }\n"])));
var Tag = /** @class */ (function (_super) {
    __extends(Tag, _super);
    function Tag() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tag.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, onClickRemove = _a.onClickRemove, removable = _a.removable, title = _a.title, subtitle = _a.subtitle, children = _a.children, showWhitespace = _a.showWhitespace, disabled = _a.disabled;
        return (React.createElement(Wrapper, { onClick: typeof onClick === 'function' ? onClick : undefined, removable: removable },
            children ? (children) : (React.createElement(React.Fragment, null,
                React.createElement(Title, null, showWhitespace ? title.replace(/\s/g, '·') : title),
                React.createElement(Subtitle, null, showWhitespace ? subtitle.replace(/\s/g, '·') : subtitle))),
            removable && !disabled && (React.createElement(A, { onClick: onClickRemove },
                React.createElement(StyledIcon, { name: "close", size: "xs", color: this.props.theme.color.primary })))));
    };
    Tag.defaultProps = {
        onClick: null,
        title: '',
        subtitle: '',
        onClickRemove: function () { },
        removable: true,
        showWhitespace: false,
        disabled: false,
    };
    return Tag;
}(React.PureComponent));
// Tag.propTypes = {
//   onClick: PropTypes.func,
//   children: PropTypes.node,
//   title: PropTypes.string,
//   subtitle: PropTypes.string,
//   onClickRemove: PropTypes.func,
//   theme: PropTypes.shape({
//     color: PropTypes.shape({
//       primary: PropTypes.string.isRequired,
//     }),
//   }).isRequired,
//   removable: PropTypes.bool,
//   showWhitespace: PropTypes.bool,
//   disabled: PropTypes.bool,
// };
exports.default = styled_components_1.withTheme(Tag);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
